import {
    Layout,
    Button,
    Page,
    Toast,
    Form,
    FormLayout,
    TextField,
    LegacyCard,
    ResourceList,
    ResourceItem, Text, Frame, EmptyState
} from '@shopify/polaris';

import {useState, useEffect, useCallback, useMemo} from 'react';
import {useLocation, useHistory} from 'react-router-dom';
import Api from "../../helpers/api";
import Paginator from "../../components/Paginator";
import {EmptyStateWithSpinner} from "../Helpers";

function useQuery() {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
}

const Users = () => {
    const queryString = useQuery();
    const history = useHistory();
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [errors, setErrors] = useState(null);
    const [loading, setLoading] = useState(false);
    const [toast, setToast] = useState({
        active: false,
        message: ''
    });
    const [meta, setMeta] = useState({currentPage: 1, lastPage: 1})

    const toastMarkup = toast.active ? (
        <Toast content={toast.message} duration={3000} onDismiss={() => { setToast({ message: '', active: false }) }} />
    ) : null;

    const assignUser = (user) => history.push(`/users/${user.id}`);

    useEffect(() => {
        if (queryString.get('q') != '' && queryString.get('q') != null) {
            setQuery(queryString.get('q'));
        }

        loadUsers(queryString.get('q'));
    }, []);

    const handleSubmit = () => {
        if (query == '') {
            setErrors('Please type something in the search field.')
            return;
        }

        history.push('/users?' + (new URLSearchParams({q: query})));
        loadUsers(query, 1, true);
    }

    const loadUsers = (q = null, page = 1, canRedirect = false) => {
        setErrors(null);
        setLoading(true);

        Api
            .findUsers({
                query: q ?? query,
                page: page
            })
            .then(({data: result}) => {
                if (result.data.length === 1 && canRedirect) {
                    assignUser(result.data[0]);
                } else if (result.data.length === 0) {
                    setResults([]);
                } else {
                    setResults(result.data);
                }
                setMeta({currentPage: result.current_page, lastPage: result.last_page});
            })
            .catch(err => {
                setToast({active: true, message: "You don't have access to that page"})
            })
            .finally(() => setLoading(false));
    };

    return (
        <Frame>
            <Page title="Users">
                <Layout>
                    <Layout.Section>
                        <Form onSubmit={handleSubmit}>
                            <FormLayout>
                                <TextField
                                    value={query}
                                    autoComplete={'on'}
                                    onChange={setQuery}
                                    label="Search users by email or name"
                                    type="text"
                                    error={errors}
                                    connectedRight={<Button submit  variant="primary">Search</Button>}
                                    clearButton
                                    onClearButtonClick={() => {
                                        setQuery('');
                                        loadUsers('');
                                    }}
                                />
                            </FormLayout>
                        </Form>
                    </Layout.Section>

                    <Layout.Section>
                        {results.length > 0 && (
                            <Paginator currentPage={meta.currentPage} lastPage={meta.lastPage} show={true} callback={(page) => loadUsers(null, page)} />
                        )}
                        <LegacyCard title="Search Results">
                            <ResourceList
                                resourceName={{ singular: 'user', plural: 'users' }}
                                items={results}
                                loading={results.length > 0 && loading}
                                emptyState={<EmptyStateWithSpinner
                                    loading={loading}
                                />}
                                renderItem={(item) => {
                                    return (
                                        <ResourceItem
                                            id={item.id}
                                            onClick={event => { assignUser(item) }}
                                            accessibilityLabel={`View details for user ${item.email}`}
                                        >
                                            <h3>
                                                <Text as={'p'} variation={"strong"}>{item.name}</Text>
                                            </h3>
                                            <div>{`Email: ${item.email}`}</div>
                                        </ResourceItem>
                                    );
                                }}
                            />
                        </LegacyCard>
                        {results.length > 0 && (
                            <Paginator currentPage={meta.currentPage} lastPage={meta.lastPage} show={true} callback={(page) => loadUsers(null, page)} />
                        )}
                    </Layout.Section>
                </Layout>
                {toastMarkup}
            </Page></Frame>
    );
}

export default Users;
